import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const updateFrameworkAgreementStatus = ({ frameworkAgreementId, status }) => {
  try {
    return axios.put(
      `/api/framework_agreements/${frameworkAgreementId}/status`,
      JSON.stringify({ Status: status })
    );
  } catch (error) {
    return error;
  }
};

export const useUpdateFrameworkAgreementStatus = (refetch) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: updateFrameworkAgreementStatus,
    onSuccess: () => {
      enqueueSnackbar('Framework agreement status successfully updated', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      refetch();
    },
    onError: (error) => {
      console.log(error);
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
